import {Location} from '@angular/common';
import {Params, Router} from '@angular/router';

export function pathOf(url: string): string {
  return url.split(/[?#]/)[0];
}

/**
 * Ersetzt die Adresszeile ohne Router: ein NavigationStart pro Filterklick räumt die Toasts weg und lässt den
 * AuthGuard erneut laufen. `null` entfernt einen Parameter, fremde Parameter bleiben stehen. Hat die Nutzerin
 * die Ansicht schon verlassen, bleibt die Adresse unangetastet.
 */
export function replaceQueryParams(location: Location, router: Router, ownPath: string, params: Params): void {
  const current = location.path(true);
  if (pathOf(current) !== ownPath) return;
  const tree = router.parseUrl(current);
  const before = router.serializeUrl(tree);
  const merged: Params = {...tree.queryParams};
  for (const [key, value] of Object.entries(params)) {
    if (value === null) delete merged[key];
    else merged[key] = value;
  }
  tree.queryParams = merged;
  const next = router.serializeUrl(tree);
  if (next === before) return;
  location.replaceState(next);
}
